import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  OPERATIONS_APPROVAL_TIME_SERIES,
  OPERATIONS_APPROVAL_TIME_Y_MAX,
  OPERATIONS_APPROVAL_TIME_Y_TICKS,
} from "../constants";
import {
  formatMinutesAxisTick,
  formatMinutesDuration,
} from "../formatDuration";
import { OperationsMetricChartWidget } from "../OperationsMetricChartWidget";
import type { OperationsApprovalTimeChartData } from "../types";

interface OperationsApprovalTimeWidgetProps {
  chart: OperationsApprovalTimeChartData;
  yAxisMax?: number;
  onExport?: (format: "csv" | "xlsx") => void;
  exportDisabled?: boolean;
  className?: string;
}

export const OperationsApprovalTimeWidget: React.FC<
  OperationsApprovalTimeWidgetProps
> = ({ chart, yAxisMax, onExport, exportDisabled, className }) => {
  const { t } = useTranslation();

  const series = useMemo(
    () =>
      OPERATIONS_APPROVAL_TIME_SERIES.map((item) => ({
        ...item,
        label: t(
          `analytics.operations.approvalTime.series.${item.key}`,
          item.label,
        ),
      })),
    [t],
  );

  return (
    <OperationsMetricChartWidget
      title={t("analytics.operations.approvalTime", "Approval time")}
      data={chart.data}
      series={series}
      yAxisMax={yAxisMax ?? OPERATIONS_APPROVAL_TIME_Y_MAX}
      yAxisTicks={
        yAxisMax && yAxisMax !== OPERATIONS_APPROVAL_TIME_Y_MAX
          ? undefined
          : [...OPERATIONS_APPROVAL_TIME_Y_TICKS]
      }
      yAxisLabel={t("analytics.operations.axis.time", "Time")}
      xAxisLabel={t("analytics.common.date", "Date")}
      formatValue={formatMinutesDuration}
      formatYAxisTick={formatMinutesAxisTick}
      showTooltipTotal={false}
      onExport={onExport}
      exportDisabled={exportDisabled}
      className={className}
    />
  );
};
